export default "__VITE_ASSET__B_S3UPWP__"